<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { currencyFormatter } from 'next/message/bubbles/Lazada/helper/formatter.js';
import { computed, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  original: {
    type: Object,
    required: true,
  },
  cached: {
    type: Object,
    required: true,
  },
});
const { t } = useI18n();
const externalUrl = computed(() => {
  return `https://sellercenter.lazada.vn/apps/order/detail?tradeOrderId=${props.original.orderId}`;
});

const orderNumber = computed(() => {
  return props.original.orderId || '';
});

const orderStatus = computed(() => {
  const status = props.cached.status || '';
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
});

const orderPrice = computed(() => {
  return currencyFormatter(props.cached.totalAmount);
});

const orderOrderedAt = computed(() => {
  return props.cached.orderedAt;
});

const thumbnailProductImage = computed(() => {
  return props.cached?.items?.[0]?.meta?.imageUrl || null;
});

const thumbnailProductName = computed(() => {
  return props.cached?.items?.[0]?.itemName || '';
});

const thumbnailProductSKU = computed(() => {
  return props.cached?.items?.[0]?.itemSku || '';
});
</script>

<template>
  <a
    :href="externalUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="no-underline"
  >
    <div class="lazada-order max-w-md w-full">
      <p class="flex items-center gap-2 border-b border-slate-100 pb-2">
        <Icon icon="i-ri-todo-fill" />
        <span class="font-semibold text-base">
          {{ t('CONVERSATION.LAZADA.ORDER.LABEL') }}
        </span>
      </p>
      <div class="mb-2">
        <span class="font-semibold">{{ orderStatus }}</span>
        <p class="text-xs mt-1">
          <span class="me-4">{{
            t('CONVERSATION.LAZADA.ORDER.ORDER_NUMBER')
          }}</span>
          <span>{{ orderNumber }}</span>
        </p>
      </div>
      <div class="flex gap-2 bg-slate-100/30 p-4 rounded-lg items-start">
        <img
          :src="thumbnailProductImage"
          alt="Order thumbnail image"
          class="w-16 h-16 object-cover rounded-lg"
        />
        <div class="flex flex-col text-xs gap-1">
          <span class="font-medium text-gray-800">{{
            thumbnailProductName
          }}</span>
          <span class="text-gray-500">{{ thumbnailProductSKU }}</span>
        </div>
      </div>
      <p class="flex justify-between mt-2">
        <span class="font-semibold">{{
          t('CONVERSATION.LAZADA.ORDER.ORDERED_AT')
        }}</span>
        <span>{{ orderOrderedAt }}</span>
      </p>
      <p class="flex justify-between">
        <span class="font-semibold">{{
          t('CONVERSATION.LAZADA.ORDER.TOTAL_PRICE')
        }}</span>
        <span class="font-semibold text-woot-600">{{ orderPrice }}</span>
      </p>
    </div>
  </a>
</template>

<style lang="scss">
.lazada-order {
  @apply bg-white dark:bg-n-slate-4 p-4 rounded-lg shadow-lg mb-4 flex flex-col;
}
</style>
